import * as ng from 'angular';

export class FileNotFoundController {
    public template = require('./404.html');
}
